import React, { useEffect, useState } from "react";
import "./Personnel_Details.css";
import Common_Back_Btn from "../../../../../../common/common_components/common_back_btn/Common_Back_Btn";
import Personnel_Details_Form from "./personnel_Details_Form/Personnel_Details_Form";
import Personnel_Details_table from "./personnel_Details_table/Personnel_Details_table";
import { Tab, Tabs } from "react-bootstrap";
import Raised_Training_table from "./raised_Training_table/Raised_Training_table";
import { GetAll } from "../../../../../../../src/features/admin/quality_management/resource_requirement/personal_detail/Slice";
import { useDispatch, useSelector } from "react-redux";
import { GETAuthLogin } from "../../../../../../features/auth/Slice";
import Training_Field_Form from "./personnel_Details_Form/TrainingField";
import { FixIDS } from "../../../../../../utils/fixIDS";

function Personnel_Details() {
  const dispatch = useDispatch();
  const [currentPage, setCurrentPage] = useState(1);
  const personaldetails = useSelector((state) => state.personnel_details);

  const authdetails = useSelector((state) => state.auth);

  const permissions = useSelector((state) => state.auth.permissions);

  const haveReadPermission = permissions?.includes(
    FixIDS.personnel_details.List,
  );
  const haveReadTPermission = permissions?.includes(
    FixIDS.training_details.List,
  );
  const havePersonalFormPermit = permissions?.includes(
    FixIDS.personnel_details.Add,
  );
  const haveTrainingFormPermit = permissions?.includes(
    FixIDS.training_details.Add,
  );

  const fetchCustomers = async (page = 1) => {
    await dispatch(
      GetAll({
        page,
        per_page: personaldetails.per_page,
      }),
    );
  };

  useEffect(() => {
    fetchCustomers(currentPage);
    dispatch(GETAuthLogin());
  }, [dispatch, currentPage]);

  console.log(personaldetails, "personaldetails personaldetails");

  return (
    <>
      <section className="Imperiality ">
        <div className="back_div">
          <Common_Back_Btn backText="Personal Details" />
        </div>

        <div className="imperiality_Form_div">
          {havePersonalFormPermit && (
            <Personnel_Details_Form fetchCustomers={fetchCustomers} />
          )}

          {haveTrainingFormPermit && <Training_Field_Form />}
        </div>

        <Tabs
          defaultActiveKey="Personnel_Details"
          id="uncontrolled-tab-example"
          className="gray_tabs_hodler mb-3"
        >
          <Tab eventKey="Personnel_Details" title="Personal Details">
            <div className="imperiality_table_div">
              {haveReadPermission && (
                <Personnel_Details_table
                  data={personaldetails}
                  setCurrentPage={setCurrentPage}
                  currentPage={currentPage}
                  fetchCustomers={fetchCustomers}
                />
              )}
            </div>
          </Tab>
          <Tab
            eventKey="Raised_Training_Request"
            title="Raised Training Request"
          >
            <div className="imperiality_table_div">
              {haveReadTPermission && <Raised_Training_table   />}
            </div>
          </Tab>
        </Tabs>
      </section>
    </>
  );
}

export default Personnel_Details;
